export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/text_animation.a5457a8.svg";